import { get } from '../ApiClient';
import EndpointProps from 'interface/EndpointProps';
import { DefaultApiResponse } from '../models/response/DefaultApiResponse';
import { fetchApiData } from '../ApiHelper';

/**
 * Fetches the scoped maintenance status.
 *
 * With an `area` the answer includes that area's windows plus whole-product
 * windows; without one it only contains whole-product windows. The payload is
 * returned untouched (`unknown`) and validated by the maintenance data layer.
 *
 * @param {EndpointProps & { area?: string }} params - The request tag and the optional area slug.
 * @returns {Promise<{ success: boolean; data: unknown; error: string | null }>} The raw `data` payload or an error message.
 */
export async function fetchMaintenanceStatus({
  tag,
  area,
}: EndpointProps & { area?: string }): Promise<{
  success: boolean;
  data: unknown;
  error: string | null;
}> {
  const url = area ? `/maintenance?area=${encodeURIComponent(area)}` : '/maintenance';
  const result = await fetchApiData<DefaultApiResponse<unknown>>(
    tag,
    () => get<DefaultApiResponse<unknown>>({ tag, url }),
    (responseData) => responseData.data ?? null,
  );

  return {
    success: result.response.status === 'success',
    data: result.response.status === 'success' ? result.response.data : null,
    error: result.response.status === 'error' ? result.response.message : null,
  };
}
